import { PLACEMENT_ROLES } from "../pages/constants"

function splitEvery(n, arr) {
  let result = []
  for (let i = 0; i < arr.length; i += n) {
    result.push(arr.slice(i, i + n))
  }
  return result
}

// interface HasPlacements {
//   placements: Array<{
//     x: number;
//     y: number;
//     type: "FEET-ONLY" | "START" | "MIDDLE" | "FINISH";
//     ledPosition: number;
//   }>;
// }

const colors = {
  FOOT: 224,
  START: 48,
  MIDDLE: 60,
  FINISH: 204,
}

colors["start"] = colors.START
colors["finish"] = colors.FINISH
colors["middle"] = colors.MIDDLE
colors["foot"] = colors.FOOT

/**
 * Compute the messages that need to be sent to the kilter
 * board to show a climb.
 *
 * This is a port of the `prepBytesV2` algorithm
 *
 * @param climb
 */
export const getBluetoothMessages = (climb) => {
  const placements = [
    80, // constant, "changed command to 'P'"

    // ...climb.placements.flatMap((placement) => {
    //   const placement_type = climb.placement_roles[i]
    //   return [
    //     placement.led_position & 255,
    //     colors[placement.type] + ((placement.led_position & 768) >> 8),
    //   ]
    // }),
    ...climb.placements
      .map((placement, i) => {
        const placement_role = climb.placement_roles[i]
        const placement_type = PLACEMENT_ROLES[placement_role]?.name
        const color = colors[placement_type]
        console.info("color: ", color)
        return [
          placement.led_position & 255,
          color + ((placement.led_position & 768) >> 8),
        ]
      })
      .flat(),
  ]
  const header = [placements.length, checksum(placements)]

  return splitMessages([1, ...header, 2, ...placements, 3])
}

/**
 * The kilter board only supports messages of 20 bytes
 * at a time. This method splits a full message into parts
 * of 20 bytes
 *
 * @param buffer
 */
export const splitMessages = (buffer) =>
  splitEvery(20, buffer).map((arr) => new Uint8Array(arr))

/**
 * The second byte of the header, ported from the Java algorithm.
 * A checksum should only contain the placement data.
 *
 * @param list
 */
export const checksum = (list) => {
  let i = 0

  list.forEach((n) => {
    i = (i + n) & 255
  })

  return ~i & 255
}

export const connectToBluetooth = async () => {
  if (!("bluetooth" in navigator)) {
    return
  }

  return navigator.bluetooth
    .requestDevice({
      filters: [
        {
          services: ["4488b571-7806-4df6-bcff-a2897e4953ff"],
        },
      ],
      optionalServices: ["6e400001-b5a3-f393-e0a9-e50e24dcca9e"],
    })
    .then((device) => {
      console.log("> Found " + device.name)
      console.log("Connecting to GATT Server...")
      return device.gatt.connect()
    })
    .then((server) => {
      console.log("GATT Server connected")
      return server.getPrimaryService("6e400001-b5a3-f393-e0a9-e50e24dcca9e")
    })
    .then((service) => {
      console.log("Getting service...")
      return service.getCharacteristic("6e400002-b5a3-f393-e0a9-e50e24dcca9e")
    })
}

async function mapSeries(array, asyncFn) {
  const results = []
  for (const item of array) {
    const result = await asyncFn(item)
    results.push(result)
  }
  return results
}

export const sendClimbToWall = (characteristic, climb) => {
  return mapSeries(getBluetoothMessages(climb), (msg) =>
    characteristic.writeValue(msg)
  )
}

export {}
